import { render } from "./MetatagsCreating.vue?vue&type=template&id=4f899242&ts=true"
import script from "./MetatagsCreating.vue?vue&type=script&lang=ts"
export * from "./MetatagsCreating.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__